import { notifications } from './notifications';

export const errors = {
    mixins: [notifications],
    data() {
        return {
            errors: {}
        }
    },
    methods: {
        handleResponseErrors(response, returnMessage = false) {
            this.errors = {};
            if (response.status === 422 && response.errors) {
                _(response.errors).keys().each(key => {
                    this.errors[key] = _.first(response.errors[key]);

                    if (returnMessage) {
                        this.pushNotification(_.first(response.errors[key]) || this.$t('notifications.errors.something_went_wrong'), 'danger');
                    }
                }).values();

                return;
            }

            if (response.status === 422 && response.data && response.data.errors) {
                _(response.data.errors).keys().each(key => {
                    this.errors[key] = _.first(response.data.errors[key]);
                }).values();

                return;
            }

            this.pushNotification(response.message || this.$t('notifications.errors.something_went_wrong'), 'danger');
        },
        validationHandler() {
            var forms = document.getElementsByClassName('needs-validation');
            var validation = Array.prototype.filter.call(forms, function (form) {
                if (!form.classList.contains('was-validated')) {
                    form.addEventListener('change', function (event) {
                        if (form.checkValidity() === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        form.classList.add('was-validated');
                    }, false);
                }
            });
        }
    }
};
